import React from 'react';
import '../styles/MediumHome.css';

interface WriteHeaderProps {
  onPublish?: () => void;
  isPublishing?: boolean;
  username?: string;
  avatarUrl?: string | null;
}

const WriteHeader: React.FC<WriteHeaderProps> = ({ onPublish, isPublishing = false, username = '用户名', avatarUrl }) => {
  return (
    <header className="write-header">
      <div className="write-header-content">
        <div className="write-header-left">
          <span className="blog-title">个人博客</span>
          <span className="write-draft-in">Draft in {username}</span>
        </div>
        <div className="write-header-right">
          <button
            className="write-publish-btn"
            onClick={onPublish}
            disabled={isPublishing}
          >
            {isPublishing ? '发布中...' : '发布'}
          </button>
          <button className="nav-icon-btn">
            {/* 通知图标 */}
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10 18a2 2 0 0 0 2-2H8a2 2 0 0 0 2 2z" fill="currentColor" />
              <path d="M16 14v-5a6 6 0 1 0-12 0v5l-2 2v1h16v-1l-2-2z" stroke="currentColor" strokeWidth="1.5" fill="none" />
            </svg>
          </button>
          <button className="nav-avatar-btn">
            {avatarUrl ? (
              <img src={avatarUrl} alt="头像" style={{ width: 32, height: 32, borderRadius: '50%' }} />
            ) : (
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                <circle cx="11" cy="11" r="10" fill="#1a8917" />
                <path d="M11 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 2c-2.33 0-7 1.17-7 3.5V18h14v-1.5C18 14.17 13.33 13 11 13z" fill="#fff" />
              </svg>
            )}
          </button>
        </div>
      </div>
    </header>
  );
};

export default WriteHeader; 